import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { actions } from 'features/auth'

import { useModalContext } from '@bcraft-frontend-lib/core'

export const Referral: React.FC = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const { pushNewModal } = useModalContext()
  const params = Object.fromEntries(new URLSearchParams(location.search).entries())
  const history = useHistory()
  const hasHandledRef = useRef(false)

  useEffect(() => {
    if (hasHandledRef.current) return
    hasHandledRef.current = true
    if (Object.keys(params).length > 0) {
      dispatch(
        actions.addAdditionalData({
          ...params,
          ...(isNaN(Number(params.pid))
            ? {
              pid: Number(params.pid),
            }
            : {}),
        }),
      )

      const redirectTo = params.redirect || ROUTE_URLS.MAIN()

      history.replace({
        pathname: redirectTo,
        search: `?openedModals=${MODAL_ROUTE_URLS.SIGN_UP()}`,
      })
    } else {
      pushNewModal(MODAL_ROUTE_URLS.SIGN_UP())()
    }
  }, [])

  return null
}
